import React, { PropTypes } from 'react';
import './styles.css';

const Img = ({ src, alt, className = 'Img' }) => <img className={className} src={src} alt={alt} />;

Img.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default Img;



/** WEBPACK FOOTER **
 ** ./src/views/components/img/index.js
 **/